import React from "react";
//#region types
import { CommissionSalaryFormTypes } from "models/formTypes";
import { CommissionSalaryReportChildrenBaseProps } from "models/propTypes/salaryDeviationPropTypes";
//#endregion
//#region components
import CommissionSalaryListView from "./listView";
import { useFilterContext } from "components/common";
//#endregion

const CommissionSalaryListContainer: React.FC<CommissionSalaryReportChildrenBaseProps> = (props) => {
  const { filter } = useFilterContext<CommissionSalaryFormTypes.Filter>();
  const { reloadList, reloadKey } = props;

  return (
    <CommissionSalaryListView filter={filter} reloadList={reloadList} reloadKey={reloadKey}></CommissionSalaryListView>
  );
};

export default CommissionSalaryListContainer;
